import React, { useEffect, useState } from "react";

const checkLocalStorage = () => {
  try {
    const testKey = "__test__";
    window.localStorage.setItem(testKey, "1");
    window.localStorage.removeItem(testKey);
    return true;
  } catch (_e) {
    return false;
  }
};

const LocalStorageWarning = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (typeof window !== "undefined" && !checkLocalStorage()) {
      setShow(true);
    }
  }, []);

  if (!show) return null;

  return (
    <div
      data-testid="localstorage-warning"
      className="bg-red-700 text-white px-4 py-3 fixed top-0 left-0 right-0 z-50 text-center shadow-md flex items-center justify-center"
      role="alert"
    >
      <span className="mr-2 font-bold">Site functionality is limited:</span>
      Your browser is blocking local storage. Please disable private browsing or adjust your browser settings for full access.
      <button
        onClick={() => setShow(false)}
        className="ml-4 px-2 py-1 bg-red-900 rounded hover:bg-red-800 focus:outline-none"
        aria-label="Dismiss warning"
      >
        ×
      </button>
    </div>
  );
};

export default LocalStorageWarning;
